var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C5DCBF0-69B6-4D54-A254-8F754E0B18E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11-12-13-Subscribe/payment/subscriptions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-12_153-payment-wrong",
    transform: "translate(-684.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Welcome-Back",
    transform: "translate(495.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_success",
    transform: "translate(189.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    fill: "#F5F5F5",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,26 C43.309,26 46,28.691 46,32 L46,32 L46,40 C46,43.309 43.309,46 40,46 L40,46 L27,46 C26.447,46 26,45.553 26,45 L26,45 L26,32 C26,28.691 28.691,26 32,26 L32,26 Z M40,28 L32,28 C29.794,28 28,29.794 28,32 L28,32 L28,44 L40,44 C42.206,44 44,42.206 44,40 L44,40 L44,32 C44,29.794 42.206,28 40,28 L40,28 Z M39.292,31.295 L40.706,32.709 L37.414,36.001 L40.706,39.293 L39.292,40.707 L36,37.415 L32.708,40.707 L31.294,39.293 L34.586,36.001 L31.294,32.709 L32.708,31.295 L36,34.587 L39.292,31.295 Z",
    id: "Combined-Shape",
    fill: "#EE786C",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic-success.810dc3adcc245333606705ad70f0bb7e.svg";
export { ForwardRef as ReactComponent };